import { useIntl } from 'react-intl';
import styled from 'styled-components';

import alertIcon from 'app/assets/leads/alert-icon.svg';
import { LeadsAccentButton, LeadsOutlineButton } from 'app/features/leads/components/leads-pill-button';
import { LeadsProfileComparison } from 'app/features/leads/components/leads-profile-comparison';

const Banner = styled.section`
  display: flex;
  gap: ${({ theme: { spacing } }) => spacing(3)};
  padding: ${({ theme: { spacing } }) => spacing(4)};
  margin-bottom: ${({ theme: { spacing } }) => spacing(6)};
  border: 0.0625rem solid ${({ theme }) => theme.semantic.neutrals_200};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
  background: ${({ theme }) => theme.semantic.neutrals_100};
`;

const BannerIcon = styled.img`
  flex-shrink: 0;
  width: 1.6875rem;
  height: 1.6875rem;
`;

const BannerContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme: { spacing } }) => spacing(3)};
  min-width: 0;
`;

const BannerTitle = styled.p`
  margin: 0;
  font-family: ${({ theme: { typography } }) => typography.poppins};
  font-size: 1.125rem;
  font-weight: ${({ theme: { typography } }) => typography.bold};
  line-height: normal;
  color: ${({ theme }) => theme.semantic.text_small_elements};
`;

const BannerBody = styled.p`
  margin: 0;
  font-family: ${({ theme: { typography } }) => typography.poppins};
  font-size: 1rem;
  font-weight: ${({ theme: { typography } }) => typography.light};
  line-height: normal;
  color: ${({ theme }) => theme.semantic.neutrals_950};
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme: { spacing } }) => spacing(2)};
`;

export const LeadsEmptyState = () => {
  const intl = useIntl();

  return (
    <>
      <Banner data-testid="leads-empty-profile-incomplete">
        <BannerIcon src={alertIcon} alt="" aria-hidden="true" />
        <BannerContent>
          <BannerTitle>{intl.formatMessage({ id: 'leads.empty.profileIncomplete.title' })}</BannerTitle>
          <BannerBody>{intl.formatMessage({ id: 'leads.empty.profileIncomplete.body' })}</BannerBody>
          <Actions>
            <LeadsOutlineButton type="button">
              {intl.formatMessage({ id: 'leads.empty.profileIncomplete.checkProfileCta' })}
            </LeadsOutlineButton>
            <LeadsAccentButton type="button">
              {intl.formatMessage({ id: 'leads.empty.profileIncomplete.updateProfileCta' })}
            </LeadsAccentButton>
          </Actions>
        </BannerContent>
      </Banner>
      <LeadsProfileComparison />
    </>
  );
};

export default LeadsEmptyState;
